import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CampusHeader from '../../../components/feature/CampusHeader';
import Footer from '../../../components/feature/Footer';
import { auth } from '../../../lib/firebase';
import { confirmPasswordReset } from 'firebase/auth';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const oobCode = searchParams.get('oobCode');

  const submit = async () => {
    setStatus(null);
    if (!oobCode) {
      setStatus('Missing reset code.');
      return;
    }
    if (password.length < 8) {
      setStatus('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      await confirmPasswordReset(auth, oobCode, password);
      setStatus('Password reset successful. You may sign in now.');
    } catch (e: any) {
      setStatus('Reset failed or link expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <CampusHeader />
      <main className="max-w-md mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">Reset Password</h1>
          <p className="text-sm text-gray-600 mb-6 text-center">Enter a new password for your account.</p>
          <div className="space-y-4">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="New password"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            />
            {status && <p className="text-sm text-red-600">{status}</p>}
            <button
              onClick={submit}
              disabled={loading}
              className="w-full px-4 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-60"
            >
              {loading ? 'Resetting…' : 'Reset Password'}
            </button>
            <button
              onClick={() => navigate('/auth/sign-in')}
              className="w-full px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ResetPasswordPage;